import { inject } from '@angular/core';
import { Observable, switchMap, take } from 'rxjs';
import { ChatService } from '@messages/infra';
import { ChatInitializer } from '../../../initializers';
import { ChatChannelType, CreateSingleChatBody, CreateSingleChatResponse } from '@core-http';

export class CreateSingleChatCommandHandler {
  private readonly chatService: ChatService = inject(ChatService);
  private readonly chatInitializer: ChatInitializer = inject(ChatInitializer);

  create(userId: string): Observable<void> {
    const payload: CreateSingleChatBody = { userId };

    return this.chatInitializer.init().pipe(
      take(1),
      switchMap(() => this.chatService.createSingleChat(payload)),
      switchMap((data: CreateSingleChatResponse) =>
        this.chatInitializer.openChannel(data.channelExternalId, ChatChannelType.single)
      )
    );
  }
}
